import {CurdDataSetConfig, FormFieldType, MobileMaintenance} from '../types';
import {toDateFormat} from '@mri/functions';
import {ChoiceTypes} from '@mri/enums';
import {propertyCommonField} from './property-common-field';

export const mobileMaintenanceDataSetConfig: CurdDataSetConfig<MobileMaintenance> = {
  entityName: 'mantenimiento',
  collectionName: 'maintenances',
  gatewayUrl: 'mobiles/maintenance',
  baseBreadcrumb: 'maintenance',
  form: {
    listRedirectUrl: 'console/maintenances/list',
    fields: [
      {
        key: 'mobileId',
        label: 'Vehiculo',
        type: FormFieldType.OPTIONS,
        containerClass: 'col-md-6 col-sm-6',
        optionsGateway: 'mobiles'
      },
      {
        key: 'class',
        label: 'Clase',
        type: FormFieldType.OPTIONS,
        containerClass: 'col-md-6 col-sm-6',
        optionsConfigKey: ChoiceTypes.MAINTENANCE_CLASS
      },
      {
        key: 'description',
        label: 'Descripccion',
        type: FormFieldType.STRING,
        containerClass: 'col-md-12 col-sm-12',
      },
      {
        type: FormFieldType.DIVIDER
      },
      {
        key: 'actionType',
        label: 'Metodo de notificacion',
        type: FormFieldType.OPTIONS,
        containerClass: 'col-md-6 col-sm-6',
        optionsConfigKey: ChoiceTypes.MAINTENANCE_ACTION
      },
      {
        key: 'valueNumber',
        label: 'A los',
        type: FormFieldType.NUMBER,
        containerClass: 'col-md-6 col-sm-6',
        hide: ({values}) => values['actionType'] === 'date'
      },
      {
        key: 'valueDate',
        label: 'A la fecha',
        type: FormFieldType.DATE,
        containerClass: 'col-md-6 col-sm-6',
        hide: ({values}) => values['actionType'] !== 'date',
      },
      {
        key: 'distanceUnit',
        label: 'Unidad de distancia',
        type: FormFieldType.OPTIONS,
        containerClass: 'col-md-6 col-sm-6',
        hide: ({values}) => values['actionType'] !== 'odometer',
        optionsConfigKey: ChoiceTypes.DISTANCE
      },

      {
        key: 'isPeriodic',
        label: '¿Es periodico?',
        type: FormFieldType.BOOLEAN,
        containerClass: 'col-md-6 col-sm-6',
        hide: ({values}) => values['actionType'] === 'date'
      },
      {
        key: 'startDate',
        label: 'A partir de',
        type: FormFieldType.DATE,
        containerClass: 'col-md-12 col-sm-12',
        fillDefaultValue: () => new Date()

      },
      {
        key: 'contactIds',
        type: FormFieldType.OPTIONS_MULTIPLE,
        label: 'Contactos',
        containerClass: 'col-md-12 col-sm-12',
        optionsGateway: 'contacts'
      },
      propertyCommonField
    ]
  },
  list: {
    pageConfig: {
      title: 'Lista de mantenimientos',
      breadcrumb: [
        {
          title: 'Mantenimientos',
          type: 'item',
          link: '/console/maintenance/list'
        },
        {
          title: 'Lista',
          type: 'item',
          link: '/console/maintenance/list',
          pageName: 'Mantenimientos'
        }
      ]
    },
    table: {
      columns: [
        { key: 'description', label: 'Descripcion' },
        { key: 'name', label: 'Placa', getValue: ({ element}) => element.mobile?.name || ''  },
        {
          key: 'status', label: 'Estado',
          getValue: ({ element }) => element.status || 'Pendiente'
        },
        {
          key: 'owner', label: 'Dueño',
          getValue: ({ element }) => element.property?.name || 'No definido'
        },
        {
          key: 'createdTime', label: 'Fecha de creación',
          getValue: ({ element }) => toDateFormat(element.createdTime)
        }
      ]
    },
    actionsKeys: ['create', 'edit', 'transfer', 'delete'],
    filter: [
      {key: 'name', label: 'Placa', type: FormFieldType.STRING},
      {
        key: 'mobileId',
        label: 'Vehiculo',
        type: FormFieldType.OPTIONS_MULTIPLE,
        optionsGateway: 'mobiles'
      },
      {
        key: 'propertyId',
        label: 'Propietario',
        type: FormFieldType.OPTIONS_MULTIPLE,
        optionsGateway: 'properties'
      },
      {
        key: 'type',
        label: 'Tipo del Vehiculo',
        type: FormFieldType.OPTIONS_MULTIPLE,
        optionsConfigKey: ChoiceTypes.MOBILE_TYPE
      },
      {
        key: 'icon',
        label: 'Icono',
        type: FormFieldType.OPTIONS_MULTIPLE,
        optionsConfigKey: ChoiceTypes.MOBILE_ICON
      }
    ],
  },
  pages: ['list', 'create', 'edit']
};
